
/**
 * 金花大乱斗
 */
export namespace GoldFlowerKind {

    export enum GeneralValue {
        /** 差值 */
        SpaceValue = 2,
        /** 最大牌数 */
        CardCount = 3,
        /** 开启次数获得紫色女娲石 */
        OPEN_GET_NVWA_STORE_5 = 3,

    }

    export const CardData = [2,3,4,5,6,7,8,9,10,'J','Q',"K",'A'];
    
    /** 牌型 */
    export enum CardType {
        Min = 1,
        /** 单张 */
        YI_ZHANG, 
        /** 一对 */
        YI_DUI, 
        /** 顺子 */
        SHUN_ZI, 
        /** 3条 */
        SAN_TIAO, 
        Max,
    }

    /** 牌型信息 */
    class CardTypeInfo {
        /** 名称 */
        name: string = '';
    }

    /** 牌型信息 */
    export const CardTypeInfoArr = {
        /** 单张 */
        [CardType.YI_ZHANG]: {
            name: '单张'
        }, 
        /** 一对 */
        [CardType.YI_DUI]: {
            name: '一对'
        },
        /** 顺子 */
        [CardType.SHUN_ZI]: {
            name: '顺子'
        },
        /** 三条 */
        [CardType.SAN_TIAO]: {
            name: '三条'
        },
    }

    /** 中奖概率信息 */
    class WinProbInfo {
        /** 概率 */
        prob: number = 0;
        /** 金额 */
        sum: number = 0;
    }

    /** 中奖概率 */
    export const WinProb: WinProbInfo[] = [
        {
            prob: 0.45
            , sum: 0
        },
        {
            prob: 0.2
            , sum: 360000
        },
        {
            prob: 0.2
            , sum: 660000
        },
        {
            prob: 0.1
            , sum: 1880000
        },
        {
            prob: 0.04
            , sum: 28880000
        },
        {
            prob: 0.01
            , sum: 100000000
        },
    ];

    /** 牌型数据 */
    export class CardTypeData {
        /** 牌 */
        card: number[] = [];
    }

}

